import React, {useEffect, useState} from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import CardSection from 'components/sales/cardSection/cardSection';
import DivLayout from 'components/sales/divLayout/divLayout';
import Images from "../../../assets/images/imageData";
import moment from "moment";

const ContractGates = ({
                           history,
                           match,
                           getGateList,
                           gateList
                       }) => {

    const currentDate = new Date();
    const date = currentDate.toISOString().split('T')[0];
    console.log(date)
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getGateList(match?.params?.comm_id, match?.params?.lead_id);
            setIsLoading(false)
        })();
    }, []);

    return (
        <Layout
            title={localization.sitesGates}
            isLoading={isLoading}
            isGoback={true}
        >

            {gateList && gateList?.length > 0 && gateList.map((value, index) => {
                {
                    console.log(value?.assets_mapping_on_gate)
                }
                return (
                    <CardSection title={localization.solution + ' ' + (index + 1) } key={index}>
                        <div className="details-listing">
                            <DivLayout
                                heading={localization.gate}
                                data={value?.lead_gate_setup_types?.name}
                            />
                            <DivLayout
                                heading={localization.gateDescription}
                                data={value?.lead_gate_setup_types?.description}
                            />
                            <DivLayout
                                heading={localization.identifier}
                                data={value?.assets_mapping_on_gate?.identifier}
                            />
                            {value.verification_date &&
                                <DivLayout
                                    heading={"Last Verified On"}
                                    data={moment(value.verification_date).format('YYYY-MM-DD')}
                                />
                            }

                            {value.verification_date && date === moment(value.verification_date).format('YYYY-MM-DD') ?
                                <div className='col-md-12 rs-text-green' style={{'padding': '15px 0px 15px 0px', fontSize:'1.7rem'}}>
                                    Verified
                                </div> :
                                <div className='col-md-12' style={{'padding': '15px 0px 15px 0px'}}>
                                    <a href={`/dashboard/gate-material/` + value?.assets_mapping_on_gate?.id + "/" + value?.assets_mapping_on_gate?.gate_id + `/${match?.params?.site_id}`}
                                       className='btn btn-primary btn-red'>Mapped Material</a>
                                </div>
                            }
                        </div>
                    </CardSection>
                )
            })}
            {gateList?.length <= 0 &&
                <div>
                    <img src={Images?.NoData} alt="" width="100%" />
                </div>
            }
        </Layout>
    );
};

export default ContractGates;
